import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { Webhook, WebhookFormValues } from '../types/webhook';
import Cookies from 'universal-cookie';
import { baseURL } from '../utils/axios.utils';

const getAuthToken = () => {
  const cookies = new Cookies();
  return cookies.get('auth_state');
};

export const useGetWebhooks = () => {
  const authToken = getAuthToken();

  const { data, isLoading, error } = useQuery<{ webhooks: Webhook[] }>({
    queryKey: ['webhooks'],
    queryFn: async () => {
      const { data } = await axios.get(`${baseURL}/clockify/webhooks`, {
        headers: { authorization: authToken },
      });
      return data;
    },
  });

  return {
    webhooks: data?.webhooks || [],
    isLoading,
    error,
  };
};

export const useCreateWebhook = () => {
  const authToken = getAuthToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (values: WebhookFormValues) => {
      const { data } = await axios.post(`${baseURL}/clockify/webhooks`, values, {
        headers: { authorization: authToken },
      });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['webhooks'] });
    },
  });
};

export const useDeleteWebhook = () => {
  const authToken = getAuthToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await axios.post(
        `${baseURL}/clockify/delete/webhook`,
        { id },
        {
          headers: { authorization: authToken },
        },
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['webhooks'] });
    },
  });
};

export const useReturnToMonday = () => {
  const authToken = getAuthToken();

  return useMutation({
    mutationFn: async () => {
      const { data } = await axios.post(
        `${baseURL}/clockify/webhooks/return`,
        { status: 'return' },
        { headers: { authorization: authToken } },
      );
      return data;
    },
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });
};
